import { render } from "./RichCardButton.vue?vue&type=template&id=88517a8e&scoped=true"
import script from "./RichCardButton.vue?vue&type=script&lang=js"
export * from "./RichCardButton.vue?vue&type=script&lang=js"

import "./RichCardButton.vue?vue&type=style&index=0&id=88517a8e&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88517a8e"]])

export default __exports__